import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from './Button'

import './ConfirmationOverlay/index.scss'

export default function RecallConfirmationOverlay({ message, subMessage, onConfirm, onCancel }: any) {
  return (
    <div className="confirmation__overlay">
      <div className="confirmation__box">
        <p className="confirmation__message">{message}</p>
        {subMessage && <p className="confirmation__sub_message">{subMessage}</p>}
        <div className="confirmation__actionblock">
          <Button color="primary" onClick={onCancel}>
            <FormattedMessage id="Cancel" defaultMessage="Cancel" />
          </Button>
          <Button color="secondary" onClick={onConfirm}>
            <FormattedMessage id="Recall" defaultMessage="Recall" />
          </Button>
        </div>
      </div>
    </div>
  )
}

RecallConfirmationOverlay.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

RecallConfirmationOverlay.defaultProps = {
  message: 'Are you sure?',
  subMessage: ''
}
